









import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

import NetworkStatusHelperComponents2Header from './network-status-helper-components-2-header.vue'
import NetworkStatusHelperComponents3ResourceList from './network-status-helper-components-3-resource-list.vue'

@Component({
  components: {
    NetworkStatusHelperComponents2Header,
    NetworkStatusHelperComponents3ResourceList
  }
})
class NetworkStatusHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean
}
export default NetworkStatusHelperComponents1MainPage
